import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface CircleStepperCurrentIconProps extends SvgIconProps {
  fillColour?: string;
  width?: string;
  height?: string;
}

const CircleStepperCurrentIcon = ({
  fillColour,
  width,
  height,
  ...props
}: CircleStepperCurrentIconProps) => {
  return (
    <SvgIcon
      {...props}
      width={width ?? "32"}
      height={height ?? "32"}
      viewBox="0 0 32 32"
      fill="none"
    >
      <rect width="32" height="32" rx="16" fill={fillColour ?? "#003FB4"} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.7071 11.2929C23.0976 11.6834 23.0976 12.3166 22.7071 12.7071L14.7071 20.7071C14.3166 21.0976 13.6834 21.0976 13.2929 20.7071L9.29289 16.7071C8.90237 16.3166 8.90237 15.6834 9.29289 15.2929C9.68342 14.9024 10.3166 14.9024 10.7071 15.2929L14 18.5858L21.2929 11.2929C21.6834 10.9024 22.3166 10.9024 22.7071 11.2929Z"
        fill="white"
      />
    </SvgIcon>
  );
};

export default CircleStepperCurrentIcon;
